import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBalearicIslands = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_896)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 6.10352e-05C18.6274 6.10352e-05 24 5.37267 24 12C24 18.6274 18.6274 24 12 24C5.37267 24 6.10352e-05 18.6274 6.10352e-05 12",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.7391 5.33338H21.9787C21.3044 4.32618 20.4816 3.42712 19.5418 2.66672H11.7391V5.33338Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.7391 10.6667H23.9259C23.8236 9.74206 23.6164 8.84923 23.3163 8.00009H11.7391V10.6667Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.683813 16.0001H23.3162C23.6163 15.1509 23.8236 14.258 23.9259 13.3333H0.0741577C0.176345 14.258 0.383626 15.151 0.683813 16.0001Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.45816 21.3333H19.5418C20.4816 20.573 21.3044 19.6738 21.9786 18.6667H2.02136C2.69561 19.6738 3.51836 20.5729 4.45816 21.3333Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 6.10352e-05C5.37262 6.10352e-05 -4.68746e-05 5.37267 3.06725e-10 12.0001C2.73871 12 5.37261 12.0001 12 12.0001L12 6.10352e-05Z",
				fill: "#4A1F63"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.91309 6.26089V7.30437H9.39137V6.26089H8.34788V7.30437H7.82617V5.21741H5.7392V7.30437H5.21744V6.26089H4.174V7.30437H3.65223V6.26089H2.6087V9.39129H10.9566V6.26089H9.91309Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_896",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgBalearicIslands;
